import axiosService from "../helpers/axiosService";
import { BASE_URL } from "../constants/ui";

const URL_FETCH_PROJECT_CATE = "api/admin/projectcate/lists";
const URL_FETCH_NEWS_CATE = "api/admin/newscate/lists";
const URL_FETCH_SLIDER = "api/admin/slideshow/lists";
const URL_FETCH_PROJECT_BY_ID = "api/get-project-by-category";
const URL_FETCH_NEWS = "api/admin/news/lists";
const URL_FETCH_ALL_PROJECT = "api/project";
const URL_FETCH_NEWS_BY_ID = "api/get-news-by-category";
const URL_FETCH_NEWS_CONTENT = "api/news";


// ------Hien code ------------------------
const URL_FETCH_ABOUT_US = "api/admin/framepage/edit";
const URL_FETCH_SHARED_LIST = "api/admin/shared/lists";
const URL_FETCH_GENERAL_CONTENT = "api/admin/general";
const URL_FETCH_DETAIL_SHARED = "api/shared";
const URL_FETCH_SEARCH = "api/tim-kiem";
const URL_CONTACT = "/api/contact";

export const fetchProjectCateApi = () => {
  return axiosService.get(`${BASE_URL}/${URL_FETCH_PROJECT_CATE}`);
};

export const fetchNewsCateApi = () => {
  return axiosService.get(`${BASE_URL}/${URL_FETCH_NEWS_CATE}`);
};

export const fetchSliderApi = () => {
  return axiosService.get(`${BASE_URL}/${URL_FETCH_SLIDER}`);
};

export const fetchProjectByIdApi = (id, page = 1, limit = 6) => {
  return axiosService.get(
    `${BASE_URL}/${URL_FETCH_PROJECT_BY_ID}/${id}?limit=${limit}&page=${page}`
  );
};

export const fetchAllProjectApi = (page = 1, limit = 6) => {
  return axiosService.get(
    `${BASE_URL}/${URL_FETCH_ALL_PROJECT}?limit=${limit}&page=${page}`
  );
};

export const fetchNewsApi = (page = 1, limit = 6) => {
  return axiosService.get(
    `${BASE_URL}/${URL_FETCH_NEWS}?limit=${limit}&page=${page}`
  );
};

export const fetchNewsByIdApi = (id, page = 1, limit = 6) => {
  return axiosService.get(
    `${BASE_URL}/${URL_FETCH_NEWS_BY_ID}/${id}?limit=${limit}&page=${page}`
  );
};

export const fetchNewsContentApi = alias => {
  return axiosService.get(`${BASE_URL}/${URL_FETCH_NEWS_CONTENT}/${alias}`);
};

// -------Hien code ------------------------------

export const fetchAboutUsApi = (id=1) => {
  return axiosService.get(`${BASE_URL}/${URL_FETCH_ABOUT_US}/${id}`);
};

export const fetchSharedListApi = () => {
  return axiosService.get(`${BASE_URL}/${URL_FETCH_SHARED_LIST}`);
};

export const fetchGeneralContentApi = () => {
  return axiosService.get(`${BASE_URL}/${URL_FETCH_GENERAL_CONTENT}`);
};

export const saveContactApi = (data) => {
  return axiosService.post(`${BASE_URL}/${URL_CONTACT}`, data);
};

export const fetchDetailSharedApi = alias => {
  return axiosService.get(`${BASE_URL}/${URL_FETCH_DETAIL_SHARED}/${alias}`);
}

export const fetchSearchApi = alias => {
  return axiosService.get(`${BASE_URL}/${URL_FETCH_SEARCH}/${alias}`);
}